/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {PropsWithChildren} from 'react'
import styled from "styled-components";
import {baseBlue} from "../../../constants/colors";
import {Typography} from '@mui/material';

const DialogHeader = styled.div({
  backgroundColor: baseBlue,
  padding: '10px 10px'
})

interface IProps {
  defaultText?: string
}

const ArgosDialogHeader = (props: PropsWithChildren<IProps>) => {

  return (
    <DialogHeader>
      {props?.children ??
        <Typography sx={{color: 'white', fontSize: 14}}>{props.defaultText}</Typography>
      }
    </DialogHeader>
  )
}

export default ArgosDialogHeader